export const loanDrilldownSidebarTypes = {
  CREATE_NEW: "createNew",
  FILE_PREVIEW: "filePreview",
  FILE_UPLOAD: "fileUpload",
  SIZER_UPLOAD: "sizerUpload",
  FORMSPY: "formSpy",
  COMMENTS: "comments",
  ADD_BORROWER: "addBorrower",
  EDIT_BORROWER: "editBorrower",
  ADD_LOAN_RELATED_CONTACT: "addLoanRelatedContact",
  ADD_PROPERTY: "addProperty",
  ADD_EXCEPTION: "addLoanException",
  ADD_LOAN_FEE: "addLoanFee",
  ADD_LOAN_CREDIT: "addLoanCredit",
  ADD_LOAN_ESCROW_ITEM: "addLoanEscrowItem",
  ADD_LOAN_SPECIAL_CONDITION: "addLoanSpecialCondition",
  ADD_EDIT_CORRESPONDENT_FEE: "addEditCorrespondentFee",
  ADD_EDIT_BROKER_TERMS: "addEditBrokerTerms",
  ADD_EDIT_THIRD_PARTY_FEES: "addEditThirdPartyFees",
  ADD_EDIT_ENTITY: "addEditEntity",
  ADD_EDIT_ENTITY_MEMBER: "addEditEntityMember",
  ADD_EDIT_LOAN_CONDITION: "addEditLoanCondition",
  UW_NOTES: "uwNotes",
  UW_CHECKLIST: "uwChecklist",
  UW_STIPS_AND_CONDITIONS: "uwStipsAndConditions",
  LOAN_TOTALS: "loanTotals",
  LOAN_CHANGE_HISTORY: "loanChangeHistory",
  EMAIL_COMPOSER: "emailComposer",
};
